import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function ServiceFIve() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios.get('https://solanthegroup.com/admin/api/services')
      .then(response => {
        setServices(response.data);
      })
      .catch(error => {
        console.error("Error fetching services:", error);
      });
  }, []);

  return (
    <>
      {services.length > 0 &&
        <div className="service-area tmp-section-gapBottom mt-5 pt-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-head">
                  <div className="section-sub-title center-title mt-5 pt-5">
                    <img src="assets/images/services/section-custom-menubar.png" alt="Business_Consulting_services" />
                    <span>OUR SERVICES</span>
                  </div>
                  <h2 className="title split-collab">Our Provided Services</h2>
                </div>
              </div>
            </div>

            <div className="row g-5">
              {services.length > 0 ? (
                services.map((service, index) => (
                  <div key={service.id} className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInUp" data-wow-duration=".8s" data-wow-delay={`.${index + 1}s`}>
                    <div className="service-inner financial-service-inner agency-service">
                      <div className="icon">
                        <img src={`https://solanthegroup.com/admin/${service.logo}`} alt={service.title} />
                      </div>
                      <div className="content">
                        <h2 className="title">{service.title}</h2>
                        {/* <p className="description" dangerouslySetInnerHTML={{ __html: service.description }}></p> */}
                        <p className="description" dangerouslySetInnerHTML={{ __html: service.description.split(" ").slice(0, 12).join(" ") }}></p>

                        <div className="three--dot" style={{
                          display: "flex",
                          gap: "5px",
                          justifyContent: "center"
                        }}>
                          <div className="dot dot-one" />
                          <div className="dot dot-two" />
                          <div className="dot dot-three" />
                        </div>
                        <Link to={`/ServiceDetails?id=${service.id}`} className="over_link"></Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p></p>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default ServiceFIve;
